export const GLOBAL_STATE = 'SDFeedback'

export const SD_FEEDBACK_RESPONSE_ALL = 'SD_FEEDBACK_RESPONSE_ALL' as const

export const SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT = 'SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT' as const

export const SD_FEEDBACK_EVALUATION_CREATE = 'SD_FEEDBACK_EVALUATION_CREATE' as const
export const SD_FEEDBACK_EVALUATION_BY_EVALUATOR = 'SD_FEEDBACK_EVALUATION_BY_EVALUATOR' as const
export const SD_FEEDBACK_EVALUATION_BY_SUBJECT = 'SD_FEEDBACK_EVALUATION_BY_SUBJECT' as const
export const SD_FEEDBACK_EVALUATION_EVALUATE_INFO = 'SD_FEEDBACK_EVALUATION_EVALUATE_INFO' as const
export const SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED = 'SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED' as const
export const SD_FEEDBACK_EVALUATION_STATS = 'SD_FEEDBACK_EVALUATION_STATS' as const

export const SD_FEEDBACK_QUESTION_ALL = 'SD_FEEDBACK_QUESTION_ALL' as const

export const SD_FEEDBACK_STAFF_ASSIGN_CREATE = 'SD_FEEDBACK_STAFF_ASSIGN_CREATE' as const
export const SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST = 'SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST' as const
export const SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST = 'SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST' as const

export const SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL = 'SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL' as const
export const SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL = 'SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL' as const
